import GeoJSON from "ol/format/GeoJSON";
import axios from "axios";
import { CqlParameter } from "./CqlParameter";
import { ServerError } from "../define/ServerError";
import { Feature } from "ol";

/**
 * WFS 地物情報（API）取得クラス
 */
export class WFSGetFeatureManager {
  /**
   * Authorizationヘッダに与えるIDトークンを設定する
   * @param idToken Authorizationヘッダに与える値
   */
  static setIdToken(_idToken: string) {
    return;
  }
  /**
   * WFS GeoJSON取得メソッド
   * @param url API通信URL
   * @param cqlParameter CQLパラメータ
   */
  async getInfo(
    url: string,
    cqlParameter: CqlParameter[],
    bbox?: number[],
    featureId?: number | string
  ): Promise<any> {
    let features: Feature[] = [];
    for (const ele of cqlParameter) {
      const config = {
        method: "GET",
        url,
        params: {
          service: "WFS",
          version: "2.0.0",
          request: "GetFeature",
          typeNames: ele._layerName,
          srsName: "EPSG:3857",
          exceptions: "application/json",
          outputFormat: "application/json",
          // layerごとに異なるため、それぞれ指定
          cql_filter: bbox
            ? `BBOX("ジオメトリ",${bbox.join(",")},'epsg:3857') AND ${
                ele._cqlParameter
              }`
            : ele._cqlParameter,
          featureID: featureId,
        },
        headers: {
          custom: "viewer",
        },
      };
      if (featureId || featureId === 0) {
        delete config.params.cql_filter;
      } else {
        delete config.params.featureID;
      }
      const response = await axios.request(config).catch((error) => {
        // エラー処理
        const messages: string[] = error?.response?.data?.exceptions.map(
          (exception: any) => exception.message
        );
        console.error(error);
        throw new ServerError(
          error.config?.url ?? url,
          error.response?.status ?? error.status,
          messages?.join("\n")
        );
      });
      // リクエスト成功時のエラー処理
      if (response?.data?.exceptions) {
        const errors = response?.data?.exceptions;
        const serverErrorList = errors.map((error: any) => {
          return new ServerError(response.config.url, error?.code, error?.text);
        });
        console.error(serverErrorList);
        throw serverErrorList;
      }
      features = features.concat(new GeoJSON().readFeatures(response.data));
    }
    const geoJSON = new GeoJSON().writeFeatures(features);
    return geoJSON;
  }
}
